// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  inner: "SectionUnemployment__inner",
  panelKey: "SectionUnemployment__panelKey",
  panelSheet: "SectionUnemployment__panelSheet",
  panels: "SectionUnemployment__panels",
  rowHead: "SectionUnemployment__rowHead",
  rowTitle: "SectionUnemployment__rowTitle",
  section: "SectionUnemployment__section",
};
